<h3 mat-dialog-title>Atualiza Status Boletas</h3>
<div mat-dialog-content>

    <div fxLayout="row wrap">
        <mat-form-field appearance="outline" floatLabel="always" fxFlex="100">
            <mat-label>Status</mat-label>
            <input matInput *ngIf="!data" [formControl]="status_id" [readonly]="true">
            <mat-error *ngIf="status_id.invalid">{{getErrorStatusMessage()}}</mat-error>
            <mat-select placeholder="Status"
                        [(value)]="model.status_id" 
                        [formControl]="status_id"
                        name="status_id"
                        *ngIf="data" >
                    <mat-option *ngFor="let status of listStatus" [value]="status.id">{{status.nome}}</mat-option>
            </mat-select>
            <mat-spinner diameter="20" *ngIf="loadingSpinnerStatus"></mat-spinner>
        </mat-form-field>
    </div>
</div>
<div mat-dialog-actions>
    <button mat-button tabindex="2" (click)="onNoClick()">Cancelar</button>
    <button mat-button [disabled]="isInvalidForm()" (click)="salvar()" tabindex="-1">Salvar</button>
</div>